export default "__VITE_ASSET__CWYWNuKQ__"